// Overlays (Sheet, Dialog) must be portalled OUT of the page tree (the sticky
// header's backdrop-blur would trap position:fixed) but still INSIDE an element
// with the .vl-revamp class, or the scoped stylesheet does not reach them.
// RevampShell creates this element; the primitives portal into it.
export const OVERLAY_ROOT_ID = "vl-revamp-overlays";

export function getOverlayRoot() {
  let el = document.getElementById(OVERLAY_ROOT_ID);
  if (!el) {
    el = document.createElement("div");
    el.id = OVERLAY_ROOT_ID;
    el.className = "vl-revamp";
    document.body.appendChild(el);
  }
  return el;
}
